import React from 'react';
import { TabsContent } from '../../ui/tabs';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../ui/card';
import { AlertCircle } from 'lucide-react';

const PRValuationTab = ({ masterData, currentItem, activeItemIndex, handleItemChange, variant }) => (
  <TabsContent value="valuation">
    <Card>
      <CardHeader>
        <CardTitle>Item {currentItem?.item_number} - Valuation</CardTitle>
        <CardDescription>Pricing and valuation information</CardDescription>
      </CardHeader>
      <CardContent>
        {currentItem && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <Label>Valuation Price</Label>
              <Input type="number" step="0.01" min="0" value={currentItem.valuation_price} onChange={(e) => handleItemChange(activeItemIndex, 'valuation_price', e.target.value)} placeholder="0.00" />
            </div>

            <div>
              <Label>Currency</Label>
              <select value={currentItem.currency} onChange={(e) => handleItemChange(activeItemIndex, 'currency', e.target.value)} className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md text-sm">
                {masterData.currencies.map((curr) => (<option key={curr} value={curr}>{curr}</option>))}
              </select>
            </div>

            {/* Per Unit UOM — Create uses dropdown, Edit uses free text */}
            <div>
              <Label>Per Unit (UOM)</Label>
              {variant === 'edit' ? (
                <Input value={currentItem.per_unit_uom} onChange={(e) => handleItemChange(activeItemIndex, 'per_unit_uom', e.target.value)} maxLength={3} placeholder="EA" />
              ) : (
                <select
                  value={currentItem.per_unit_uom}
                  onChange={(e) => handleItemChange(activeItemIndex, 'per_unit_uom', e.target.value)}
                  className="w-full h-10 px-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500"
                >
                  <option value="">Select UOM</option>
                  {masterData.unitsOfMeasure.map((uom) => (
                    <option key={uom.unit_code} value={uom.unit_code}>{uom.unit_code} - {uom.description}</option>
                  ))}
                </select>
              )}
            </div>

            <div>
              <Label>Estimated Unit Price</Label>
              <Input type="number" step="0.01" min="0" value={currentItem.estimated_unit_price} onChange={(e) => handleItemChange(activeItemIndex, 'estimated_unit_price', e.target.value)} placeholder="0.00" />
            </div>

            <div>
              <Label>Price Currency</Label>
              <select value={currentItem.price_currency} onChange={(e) => handleItemChange(activeItemIndex, 'price_currency', e.target.value)} className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md text-sm">
                {masterData.currencies.map((curr) => (<option key={curr} value={curr}>{curr}</option>))}
              </select>
            </div>

            <div>
              <Label>Total Value (Auto-calculated)</Label>
              <Input type="number" value={currentItem.total_value} readOnly className="bg-gray-100" placeholder="Calculated" />
            </div>

            <div className="md:col-span-3">
              <div className="bg-amber-50 p-3 rounded-md flex items-start gap-2">
                <AlertCircle className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" />
                <div className="text-sm text-amber-800">
                  <strong>Total Value Calculation:</strong> Total Value = Valuation Price × Quantity
                  {currentItem.valuation_price && currentItem.quantity && (
                    <div className="mt-1">= {currentItem.valuation_price} × {currentItem.quantity} = {currentItem.total_value || 0} {currentItem.currency}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  </TabsContent>
);

export default PRValuationTab;
